import { render, staticRenderFns } from "./ProvidersFilter.vue?vue&type=template&id=6049cd46&scoped=true&"
import script from "./ProvidersFilter.vue?vue&type=script&lang=js&"
export * from "./ProvidersFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6049cd46",
  null
  
)

export default component.exports